__webpack_require__.p = "/foomo/modules/SipShop.Core/";